<template>
    <ServicePageLayout
        title="Техническая поддержка сайтов"
        description="Сопровождаю сайты после запуска: обновляю контент, исправляю ошибки, контролирую работоспособность и помогаю развивать проект."
        :includes="includes"
        :audience="audience"
        :steps="steps"
        price="Стоимость технической поддержки — от 7 000 ₽/месяц. Разовые задачи — от 1 000 ₽/час."
    />
</template>

<script setup>
import ServicePageLayout from '@/components/cards/ServicePageLayout.vue';

const includes = [
    'обновление текстов, изображений и блоков',
    'контроль работоспособности сайта',
    'исправление технических ошибок',
    'добавление небольших доработок',
    'базовые SEO-улучшения и консультации',
];

const audience = [
    'владельцам сайтов после запуска',
    'малому бизнесу',
    'экспертам и частным специалистам',
    'проектам, которым нужна регулярная поддержка',
];

const steps = [
    'обсуждение задач и формата поддержки',
    'оценка объёма работ',
    'выполнение текущих задач',
    'проверка корректной работы сайта',
    'регулярное сопровождение при необходимости',
];
</script>